/** JK Loom design tokens — source: DESIGN_WEB.md */

export const jkLoomLight = {
  parchment: '#FCF0DA',
  surface: '#fcf9f8',
  surfaceContainer: '#f0eded',
  onSurface: '#1b1b1c',
  onSurfaceVariant: '#4c4451',
  outline: '#7d7483',
  outlineVariant: '#cec3d3',
  primary: '#2e0052',
  primaryContainer: '#4b0082',
  onPrimary: '#ffffff',
  onPrimaryContainer: '#ba7ef4',
  primaryFixed: '#f0dbff',
  primaryFixedDim: '#ddb7ff',
  secondary: '#5c5d6e',
  secondaryContainer: '#e1e1f5',
  tertiary: '#c98e1c',
  tertiaryDim: '#fcbb49',
  error: '#ba1a1a',
  errorContainer: '#ffdad6',
  success: '#00C875',
  statusError: '#FF3D57',
  card: '#ffffff',
  divider: 'rgba(0, 0, 0, 0.05)',
  tableHover: 'rgba(230, 230, 250, 0.3)',
  kpiCard: '#E6E6FA',
};

export const jkLoomDark = {
  deep: '#0F0A1A',
  surface: '#181224',
  surfaceElevated: '#221830',
  onSurface: '#f3f0ef',
  onSurfaceVariant: '#cec3d3',
  outline: '#7d7483',
  outlineVariant: '#4c4451',
  primary: '#ddb7ff',
  primaryContainer: '#4b0082',
  onPrimary: '#2c0050',
  onPrimaryContainer: '#ba7ef4',
  secondary: '#c5c5d8',
  secondaryContainer: '#444655',
  tertiary: '#fcbb49',
  error: '#ffb4ab',
  errorContainer: '#93000a',
  success: '#00C875',
  statusError: '#FF3D57',
  card: '#181224',
  divider: 'rgba(255, 255, 255, 0.1)',
  glassBorder: 'rgba(255, 255, 255, 0.1)',
  ambientGlow: 'rgba(75, 0, 130, 0.08)',
  tableHover: 'rgba(75, 0, 130, 0.12)',
  kpiCard: '#221830',
};

export const jkLoomShape = {
  button: 8,
  card: 16,
  chip: 9999,
};

export const jkLoomShadow = {
  floating: '0px 10px 30px rgba(0, 0, 0, 0.08)',
  floatingDark: '0px 10px 30px rgba(0, 0, 0, 0.35)',
  glowDark: '0 0 40px rgba(75, 0, 130, 0.15)',
};
